<template>
  <div class="layout-features">
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.layout-features {
  margin: 5em 0;
}
.container {
  background: var(--light);
  display: flex;
  text-align: center;
  padding: 1.25em;
  & > * {
    flex-grow: 1;
    margin: 0 2em;
    img {
      height: 50px;
      margin: auto;
    }
    & > * {
      margin: 0.5em;
    }
  }
}
@media screen and (max-width: 767px) {
  .layout-features {
    .container {
      display: block;
      & > * {
        margin: 2em 0;
      }
    }
  }
}
</style>
